import apiUrls from 'apis/apiUrls';
import { axiosInstance } from 'helper/axiosHelper';

const userService = {
  getAllUser: (params: { storeManager: any }) => {
    return axiosInstance.makeGetRequest({
      url: apiUrls.getAllUser(),
      config: { params },
    });
  },

  addUser: (data: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.addUser(),
      data: { ...data, portal: 'CLIENT' },
    });
  },

  deleteUser: (params: { id: string }) => {
    return axiosInstance.makeDeleteRequest({
      url: apiUrls.deleteUser(),
      config: { params },
    });
  },

  sendPassword: (params: { userId: string; companyId: string }) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.sendPassword(),
      config: { params },
      // data,
    });
  },

  sendResetPasswordLink: (data: { username: string }) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.sendResetPasswordLink(),
      data: { username: data.username, portal: 'CLIENT' },
    });
  },

  getFilteredUser: (data: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.getFilteredUser(),
      data,
    });
  },
};

export default userService;
